import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useAppSelector } from '../../hooks/redux';
import PageHero from '../../components/PageHero';

export default function FaqPage() {
  const content = useAppSelector((s) => s.geo.content);
  const [open, setOpen] = useState<number | null>(0);

  return (
    <>
      <PageHero badge="Help" title="Frequently" titleAccent="asked" subtitle={`Answers for ${content.countryLabel} visitors — all in English, local policy context.`} />
      <section style={{ padding: '64px 0', background: '#FFFBF8' }}>
        <div className="container-wide" style={{ maxWidth: 800 }}>
          {content.faq.map((item, i) => (
            <div key={item.q} style={{ background: 'white', border: '1px solid #F0C8D8', borderRadius: 14, marginBottom: 10, overflow: 'hidden' }}>
              <button
                type="button"
                onClick={() => setOpen(open === i ? null : i)}
                style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, padding: '16px 18px', background: open === i ? '#FFF0F5' : 'white', border: 'none', cursor: 'pointer', textAlign: 'left' }}
              >
                <span style={{ fontSize: 15, fontWeight: 700, color: '#1A0A10' }}>{item.q}</span>
                <ChevronDown size={16} color="#C2185B" style={{ transform: open === i ? 'rotate(180deg)' : undefined, transition: '0.2s' }} />
              </button>
              {open === i && <p style={{ margin: 0, padding: '0 18px 16px', fontSize: 14.5, color: '#6B3A52', lineHeight: 1.7 }}>{item.a}</p>}
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
